import ProgressBar from '@/components/progressBar/ProgressBar';
import { RootState } from '@/store';
import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { ISideNavigationBarProps } from '../../user/userSideBar/SideNavigationBarTypes';

const AdminViewFormSideBar: React.FC<ISideNavigationBarProps> = ({
  sections,
  onSectionClick,
  isProgressBarShow = true,
}) => {
  const sectionId = useSelector((state: RootState) => state?.sectionId.sectionId);
  const containerRef = useRef<HTMLDivElement>(null);
  const selectedItemRef = useRef<HTMLDivElement>(null);
  // Scroll to the selected section
  useEffect(() => {
    if (selectedItemRef.current && containerRef.current) {
      selectedItemRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
    }
  }, [sectionId]);

  const handleSectionClick = (sectionObj: { section_id: string; section_name: string }) => {
    if (onSectionClick) {
      onSectionClick(sectionObj);
    }
  };
  return (
    <>
      <div
        ref={containerRef}
        className="lg:h-full bg-white overflow-y-auto overflow-x-hidden mr-2 border-b-1 border-ds-gray-100 p-2 rounded-md"
      >
        <div className="flex flex-col">
          <div className="text-ds-gray-300 px-2 py-2">
            {sections?.map((section) => {
              const isSelected = section?.section_id === sectionId;

              // If it's the disabled certification section, wrap it in a Tooltip
              return (
                <div
                  key={section.section_id}
                  ref={isSelected ? selectedItemRef : null}
                  onClick={() => handleSectionClick(section)}
                  className={`
                    w-[220px] mb-2 rounded-[6px] overflow-hidden
                    ${isSelected ? 'border border-ds-mc-blue-600' : 'border border-transparent'}
                    cursor-pointer
                  `}
                >
                  <div
                    className={`
                    flex items-center justify-between px-3 ${section.section_name !== 'Instructions' || !isProgressBarShow ? 'py-3' : 'py-[18px]'}
                    ${isSelected ? 'bg-ds-mc-blue-100 text-ds-mc-blue-600' : 'text-ds-gray-600'}
                  `}
                  >
                    <span className="text-xs font-medium w-[180px]">{section.section_name}</span>
                    {section.section_name !== 'Instructions' && isProgressBarShow && (
                      <ProgressBar value={section.progress_percentage ?? 0} />
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};

export default AdminViewFormSideBar;
